var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xl-6 col-12 single-card-container" },
          [
            _c("div", { staticClass: "row d-flex d-lg-none" }, [
              _c("div", { staticClass: "card card-separator" }, [
                _c("div", { staticClass: "card-header px-5" }, [
                  _c("div", { staticClass: "row align-items-end" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "h2",
                        { staticClass: "section-separator-title text-primary" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.getFullName("main-applicant") ||
                                  _vm.$t("application-form.main-applicant")
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.getFullName("main-applicant")
                        ? _c("h3", { staticClass: "section-separator-title" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t("application-form.main-applicant")
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("applicant", {
              attrs: {
                "applicant-index": 0,
                type: "main-applicant",
                "type-title": _vm.$t("application-form.main-applicant"),
                "edit-visibility": _vm.editVisibility,
                "current-application": _vm.currentApplication,
                "application-id": _vm.applicationId,
                "client-username": _vm.clientUsername,
                "agent-username": _vm.agentUsername,
              },
              on: {
                "change-height": _vm.handleChangeHeight,
                "height-remove": _vm.handleHeightRemove,
                replicate: _vm.handleReplicate,
                save: _vm.handleSave,
                "page-change": _vm.handlePageChange,
                "toggle-visibility": _vm.handleVisibility,
                "open-life-insurance-modal": _vm.handleOpenLifeInsuranceModal,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xl-6 single-card-container" },
          [
            _c("div", { staticClass: "row d-flex d-lg-none mt-5" }, [
              _c("div", { staticClass: "card card-separator" }, [
                _c("div", { staticClass: "card-header px-5" }, [
                  _c("div", { staticClass: "row align-items-end" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "h2",
                        { staticClass: "section-separator-title text-primary" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.getFullName("co-applicants[0]") ||
                                  _vm.$t("application-form.coApplicant")
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.getFullName("co-applicants[0]")
                        ? _c("h3", { staticClass: "section-separator-title" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("application-form.coApplicant")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("applicant", {
              attrs: {
                "applicant-index": 1,
                type: "co-applicants[0]",
                "replicate-address": true,
                "edit-visibility": _vm.editVisibility,
                "type-title": _vm.$t("application-form.co-applicant"),
                "current-application": _vm.currentApplication,
                "application-id": _vm.applicationId,
                "client-username": _vm.clientUsername,
                "agent-username": _vm.agentUsername,
              },
              on: {
                "change-height": _vm.handleChangeHeight,
                "height-remove": _vm.handleHeightRemove,
                replicate: _vm.handleReplicate,
                save: _vm.handleSave,
                "page-change": _vm.handlePageChange,
                "toggle-visibility": _vm.handleVisibility,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.editVisibility
        ? _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              {
                attrs: {
                  id: _vm._f("hashId")("main-applicant[other-properties]"),
                },
              },
              [
                _c("other-properties", {
                  attrs: {
                    "current-application": _vm.currentApplication,
                    "applicant-index": 0,
                    "edit-visibility": true,
                  },
                  on: {
                    "change-height": _vm.handleChangeHeight,
                    save: _vm.handleSave,
                    "toggle-visibility": _vm.handleVisibility,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("life-insurance-modal", { ref: "lifeInsuranceModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }